var _polygon, _polyline, _polyline2, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _polyline3, _polyline4, _line13, _polyline5, _polyline6, _polyline7, _line14, _line15, _line16, _line17, _line18, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _path4, _circle, _circle2, _circle3, _line19, _line20, _line21, _line22, _line23, _circle4, _circle5, _circle6, _line24, _line25, _line26, _line27, _line28, _polyline14, _polyline15, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChassisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1105.007 128.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "307.264 114.87 307.264 79.988 307.264 23.547 322.382 23.547 322.382 48.283 322.382 114.789 307.264 114.87",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "307.264 80.582 322.469 80.582 379.766 48.073",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "308.023 113.966 306.049 115.94 296.543 126.921 332.954 127.092 323.278 115.254 322.042 113.765",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m906.72,47.838c-194.779.148-389.558.297-584.338.446",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1012.881,47.756c-3.892.003-37.282.028-66.444.051",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m322.382,23.547l759.283-.961v25.118c-10.586.008-21.171.016-31.757.024",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 334.4,
    y1: 48.107,
    x2: 334.4,
    y2: 23.432,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 354.751,
    y1: 32.788,
    x2: 333.542,
    y2: 32.788,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 353.258,
    y1: 42.277,
    x2: 353.258,
    y2: 31.427,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 354.726,
    y1: 40.785,
    x2: 333.517,
    y2: 40.785,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 383.558,
    y1: 33.006,
    x2: 360.159,
    y2: 33.006,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 382.115,
    y1: 42.495,
    x2: 382.115,
    y2: 31.645,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 383.53,
    y1: 41.003,
    x2: 360.131,
    y2: 41.003,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 361.634,
    y1: 42.442,
    x2: 361.634,
    y2: 31.592,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 431.088,
    y1: 33.135,
    x2: 418.748,
    y2: 33.135,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 430.298,
    y1: 42.485,
    x2: 430.298,
    y2: 31.636,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 431.044,
    y1: 40.983,
    x2: 418.704,
    y2: 40.983,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 419.496,
    y1: 42.485,
    x2: 419.496,
    y2: 31.635,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "307.264 23.547 1.5 23.547 1.5 31.2 129.353 31.2 129.353 23.507",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "4.117 23.235 4.117 1.5 25.852 1.5 25.852 22.779",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 9.323,
    y1: 1.318,
    x2: 9.323,
    y2: 22.322,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "26.298 12.135 288.439 12.135 300.033 23.728",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "306.763 47.56 282.148 47.56 250.325 23.643 250.325 11.773",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "87.061 31.535 87.061 38.555 97.486 38.555 97.486 31.168",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 412.637,
    y1: 33.004,
    x2: 389.238,
    y2: 33.004,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 411.193,
    y1: 42.493,
    x2: 411.193,
    y2: 31.643,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 412.609,
    y1: 41.001,
    x2: 389.209,
    y2: 41.001,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 390.712,
    y1: 42.44,
    x2: 390.712,
    y2: 31.59,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 595.65,
    y1: 23.203,
    x2: 595.65,
    y2: 47.858,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "884.843 22.429 884.843 46.868 884.843 60.102",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "895.971 23.053 895.971 47.18 895.971 56.006",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "990.815 22.039 990.815 46.478 990.815 60.029",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "1001.942 22.663 1001.942 46.79 1001.942 55.677",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "1081.665 22.586 1081.665 16.175 1095.843 16.175 1095.843 35.828 1081.892 35.828",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    points: "1095.972 35.828 1103.507 35.828 1103.507 85.809 1081.654 85.809 1081.654 47.704",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1081.413,75.859s-10.291-21.488-23.266-28.203",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Back_Tire",
    "data-name": "Back Tire",
    cx: 1031.529,
    cy: 84.931,
    r: 41.323,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1031.632,
    cy: 85.251,
    r: 22.776,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1031.722,
    cy: 85.624,
    r: 7.781,
    strokeWidth: 0
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 1031.74,
    y1: 79.09,
    x2: 1031.74,
    y2: 65.575,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1037.293,
    y1: 84.083,
    x2: 1049.941,
    y2: 79.319,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 1025.982,
    y1: 83.161,
    x2: 1013.334,
    y2: 78.398,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 1028.159,
    y1: 90.569,
    x2: 1019.553,
    y2: 100.99,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1044.644,
    y1: 100.836,
    x2: 1036.038,
    y2: 90.415,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Back_Tire-2",
    "data-name": "Back Tire-2",
    cx: 926.54,
    cy: 84.099,
    r: 41.323,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.643,
    cy: 84.419,
    r: 22.776,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.733,
    cy: 84.793,
    r: 7.781,
    strokeWidth: 0
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 926.751,
    y1: 78.258,
    x2: 926.751,
    y2: 64.743,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 932.304,
    y1: 83.251,
    x2: 944.952,
    y2: 78.487,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 920.993,
    y1: 82.329,
    x2: 908.345,
    y2: 77.566,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 923.17,
    y1: 89.737,
    x2: 914.564,
    y2: 100.158,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 939.655,
    y1: 100.005,
    x2: 931.049,
    y2: 89.583,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    points: "997.841 59.699 979.161 59.699 979.161 73.434 990.699 73.434",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    points: "893.425 60.405 874.745 60.405 874.745 74.14 886.282 74.14",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 400.722,
    y: 33.844,
    width: 9.157,
    height: 6.487,
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.432,
    y: 24.362,
    width: 8.746,
    height: 6.045,
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.023,
    y: 24.748,
    width: 8.746,
    height: 6.045,
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChassisIcon);
export default __webpack_public_path__ + "static/media/chassis-icon.c1d19c1ac2fc394424a790625e2b1601.svg";
export { ForwardRef as ReactComponent };